import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { currencyValueTickFormatter } from 'src/utils/TickFormatters';
import { useCurrency } from 'src/hooks/useCurrency';
import { MEDIA_INVESTMENT_DEF } from 'src/utils/metricDefinitions';
import { useAggregationLevelContext } from '../../contexts/AggregationLevelContext';
import { useGetDateAxisFormatter } from '../../hooks/useGetDateAxisFormatter';
import { getAggregateLevelData } from '../../utils/getAggregateLevelData';
import { TimeseriesDataTableModal } from '../molecules/TimeseriesDataTableModal';

const title = 'Media investment';

export const MediaInvestmentBox: React.FC = () => {
  const { investments } = useMMDataContext();
  const { aggregateLevel } = useAggregationLevelContext();
  const { code } = useCurrency();
  const investmentTickFormatter = currencyValueTickFormatter(code);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return getAggregateLevelData(investments, aggregateLevel);
  }, [investments, aggregateLevel]);

  const xAxisFormatter = useGetDateAxisFormatter();

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel="Investment"
      data={data}
      xAxisFormatter={xAxisFormatter}
      yAxisFormatter={investmentTickFormatter}
      isError={investments.isError}
      isLoading={investments.isLoading}
      infoText={MEDIA_INVESTMENT_DEF}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={investmentTickFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
